import { IllegalArgumentError } from 'faro-common-model';
import { StudyEntityType } from '../study-entity-type.js';
import { baseStudyEntityValidationSchema } from '../validation/index.js';
import { z } from 'zod';
import { bclAssessmentMeasurementSchema } from '../biomedical-library-proxy.js';
export const studyAssessmentMeasurementSchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    assessmentMeasurement: bclAssessmentMeasurementSchema,
    entityType: z
        .literal(StudyEntityType.StudyAssessmentMeasurement)
        .default(StudyEntityType.StudyAssessmentMeasurement),
});
/**
 * Convert an object to a StudyAssessmentMeasurement.
 * @param studyAssessmentMeasurement The object to convert.
 * @returns The converted StudyAssessmentMeasurement.
 */
export function toStudyAssessmentMeasurement(studyAssessmentMeasurement) {
    const result = studyAssessmentMeasurementSchema.safeParse(studyAssessmentMeasurement);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid StudyAssessmentMeasurement object. ${result.error.message}`);
    }
    return result.data;
}
/**
 * Check if an object is a StudyAssessmentMeasurement.
 * @param am The object to check.
 * @returns True if the object is a StudyAssessmentMeasurement.
 *
 * @deprecated This function should not be used. Consumers should know their models.
 */
export function isStudyAssessmentMeasurement(am) {
    if (typeof am !== 'object' || am === null) {
        return false;
    }
    return 'assessmentMeasurement' in am;
}
//# sourceMappingURL=study-assessment-measurement.js.map